/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Intishigheraspect10Inputs */

const de__class_intishigheraspect10 = /** @type {(inputs: _Class_Intishigheraspect10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ist größer-gleich`)
};

/**

* @param {_Class_Intishigheraspect10Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_intishigheraspect10 = /** @type {((inputs?: _Class_Intishigheraspect10Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Intishigheraspect10Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_intishigheraspect10(inputs)
});
export { _class_intishigheraspect10 as "_class_IntISHIGHERAspect" }